
// 数据库类型
export function getDbType(){
    return [{
        name: 'Mysql',
        value: 1
    },{
        name: 'SqlServer',
        value: 2
    },{
        name: 'Oracle',
        value: 3
    },{
        name: 'PostgreSQL',
        value: 4
    }];
}

// 默认配置
export function getSetting(){
    return {
        version: process.env.VERSION,
        name: '内部测试版',
        date: '2099-08-04'
    }
}

// 环境变量字典
export const envOptions = [{
    label: '当前登陆人',
    value: 0,
    items: [{
        label: '姓名',
        value: 0
    }, {
        label: '部门',
        value: 1
    },{
        label: '账号',
        value: 2
    },{
        label: '手机号码',
        value: 3
    },{
        label: '角色',
        value: 5
    }]
    },{
        label: '当前环境',
        value: 1,
        items: [{
            label: '当前时间',
            value: 4
        }]
    }
]

// 计算公式字典
export const calcOption = [{
        label: '等于',
        value: 0
    },
    {
        label: '包含',
        value: 1
    },
    {
        label: '不等于',
        value: 2
    },
    {
        label: '不包含',
        value: 3
    }
]

// 字典缓存
let dicListCache = null
let dicListCacheTime = null
const CACHE_DURATION = 5 * 60 * 1000 // 5分钟缓存

/**
 * 获取字典列表（带缓存）
 */
export async function getDicListWithCache() {
    const now = Date.now()
    if (dicListCache && dicListCacheTime && (now - dicListCacheTime) < CACHE_DURATION) {
        return dicListCache
    }
    
    const { getDic } = await import('@/services/dic.service')
    try {
        const list = await getDic()
        dicListCache = Array.isArray(list) ? list : []
        dicListCacheTime = now
        return dicListCache
    } catch (e) {
        console.error('获取字典列表失败:', e)
        return []
    }
}

/**
 * 通过字典名称获取字典数据（不使用缓存，直接查询）
 * @param {string} dicName 字典名称
 * @param {string} searchValue 查询参数（可选）
 * @returns {Promise<Array>} 字典数据数组，格式: [{name: '显示名称', value: '存储值'}, ...]
 */
export async function getDicDataByName(dicName, searchValue = '') {
    if (!dicName) {
        return []
    }
    
    try {
        // 直接获取字典列表（不使用缓存）
        const { getDic } = await import('@/services/dic.service')
        const dicList = await getDic()
        
        if (!Array.isArray(dicList)) {
            console.warn('字典列表格式错误')
            return []
        }
        
        // 查找指定名称的字典
        const dic = dicList.find(item => item.name === dicName)
        if (!dic || !dic.id) {
            console.warn(`未找到名称为"${dicName}"的字典`)
            return []
        }
        
        // 获取字典数据，使用searchValue参数
        const { getDicData } = await import('@/services/dic.service')
        const data = await getDicData(dic.id, searchValue)
        
        // 标准化返回格式：确保返回格式为 [{name, value}]
        if (Array.isArray(data)) {
            return data.map(item => {
                // 如果已经是标准格式，直接返回
                if (item.name && item.value !== undefined) {
                    return item
                }
                // 如果是其他格式，尝试转换
                if (item.label && item.value !== undefined) {
                    return { name: item.label, value: item.value }
                }
                // 如果是字符串数组，转换为 {name, value}
                if (typeof item === 'string') {
                    return { name: item, value: item }
                }
                return item
            })
        }
        
        return []
    } catch (e) {
        console.error(`获取字典"${dicName}"数据失败:`, e)
        return []
    }
}